const date = new Date();
const this_year = '31-12-' + date.getFullYear().toString();
const next_year = '31-12-' + (date.getFullYear() + 1).toString();

export default {
  labels: {
    company_name: 'Company Name',
    headquarters: "Company's registered office",
    office_address: "Company's Location",
    place_of_business: "Company's statutory seat",
    postal_code: "Company's postal code",
    activities: 'Describe here the activities of the company',
    sell_products: 'Does the company sell products to consumers or companies?',
    where_are_sold: 'Where are these products sold?',
    export_products: 'Will the company export products and/or services?',
    import_products: 'Will the company import products and/or services?',
    number_of_shares: 'Amount of shares',
    value_of_shares: 'What will be the value of a share?',
    financial_year_end: 'When does the company`s first financial year end?',
    full_time_work:
      'How many people work full-time (15 hours or more per week) at the location?',
    part_time_work:
      'How many people work part-time (15 hours or more per week) at the location?',
    employees_loan: 'Is there incidental loan of employees?',
    representation:
      'Which signature system will apply when representing the company?',
    custom_notary: 'Notary that will perform the legislation',
    custom_notary_city: 'Your area',
    kvk: 'KvK-number',
    purchase_agreement:
      'Is there already a purchase agreement between the seller and buyer for the share transfer?',
    purchase_price_received:
      'Has the purchase price of the shares already been received by the seller?',
    old_acquistion:
      'Did the seller acquire the shares in the company before 1993?',
    old_acquistion_date:
      'What is the date of the deed of transfer under which the seller acquired the shares?',
    received_shares:
      'Did the seller acquire the shares upon incorporation of the company?',
    received_shares_date: 'On what date did the seller acquire the shares?',
    incorporation_date: 'What is the date of incorporation of the company?',
    statutes_adopted_date:
      'On what date were the current statutes of the company adopted?',
    shares_rights_date:
      "From what date are all benefits and burdens of the shares for the buyer's account?",
    transfer_rights_date:
      'State here the date of transfer of all benefits and burdens of the shares to the buyer?',
    notarial_costs: 'The notarial costs for the share transfer are borne by:',
    shares_from: '--------',
    shares_to: '--------',
    share_type: '--------',
    shares_price_expl: '--------',
    lead_approval:
      'Would you like to receive 3 free quotes from our selected bookkeepers from your region without obligation?'
  },
  placeholders: {
    headquarters: 'Company Location',
    office_address: 'Enter full address',
    place_of_business: 'Enter full address',
    company_name: 'Type here your company name',
    holding_name: 'Type here your holding name',
    postal_code: 'Enter postal Code',
    website: 'Enter the website address',
    activities: 'Describe about the company....',
    sell_products: 'Select from the list ',
    where_are_sold: 'Select from the list',
    total_shares: 'Total shares',
    value_of_shares: 'Enter value',
    enter_number: 'Enter Number',
    financial_year_end: '',
    full_time_work: 'Enter Number',
    part_time_work: 'Enter Number',
    number_of_shares: 'Enter the number of share',
    value_shares: 'Enter the valuation of share',
    shares: 'Enter number',
    custom_notary:
      'Fill in name, city and phone number of the notary that will perform the legislation',
    custom_notary_city: 'Fill in Information about your area',
    kvk: '',
    purchase_agreement: '',
    purchase_price_received: '',
    old_acquistion: '',
    old_acquistion_date: '',
    received_shares: '',
    received_shares_date: '',
    incorporation_date: '',
    statutes_adopted_date: '',
    shares_rights_date: '',
    transfer_rights_date: '',
    notarial_costs: '',
    shares_from: '',
    shares_to: '',
    share_type: '',
    shares_price_expl: ''
  },
  options: {
    sell_products: {
      consumers: 'To consumers',
      companies: 'To companies',
      none: 'Does not apply',
      consumers_and_businesses: 'To both consumers and businesses'
    },
    where_are_sold: {
      store_or_kiosk: 'In a store or kiosk',
      market: 'On the market',
      street_trade: 'Via street trade',
      internet: 'Through Internet',
      from_home: 'From home',
      postorder: 'For postorder',
      not_applicable: 'Does not apply'
    },
    representation: {
      one_signature:
        '1 signature system, in which each director is independently authorized',
      two_signatures:
        '2 signature system, in which 2 directors acting jointly are authorized'
    },
    financial_year_end: {
      this_year: this_year,
      next_year: next_year
    },
    shares_rights_date: {
      date_of_transfer: 'As of the date of the deed of transfer of shares',
      other_date:
        'On a date other than the date of the deed of transfer of shares'
    },
    notarial_costs: {
      seller: 'Verkoper',
      buyer: 'Koper'
    }
  }
};
